module.exports = __webpack_public_path__ + "static/media/logo.fc7840e4.svg";